import { gql } from 'apollo-angular';

export const GET_MANUAL_JOURNALS = gql`
  query journals($search: String,$status: JournalStatus) {
    journals(search: $search, status: $status) {
      id
      journalNo
      refType
      refId
      reference
      notes
      createdBy
      totalAmount
      postedAt
      status
      date
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const GET_JOURNAL_BY_ID = gql`
  query journal($id: Int!) {
    journal(id: $id) {
      id
    journalNo
    refType
    refId
    reference
    notes
    createdBy
    postedAt
    status
    totalAmount
    date
    journalEntries {
      id
      journalId
      debit
      accountId
      accountData{
        id 
        accountName
      }
      credit
      description
    }
    createdAt
    updatedAt
    }
  }
`;
